import img from '/src/loading/loading.gif'
function loading(){
	// 2147483647
	closeLoading()
	let node = document.createElement('div')
	document.body.appendChild(node)
	node.style.position = 'absolute'
	node.style.left = '0px'
	node.style.top = '0px'
	node.style.width = '100%'
	node.style.height = '100%'
	node.style.zIndex = '2147483647'
	node.style.background = 'url('+img+') no-repeat'
	node.style.backgroundPosition = 'center center'
	node.style.backgroundSize = '100px 100px'
	node.id = 'loading_div'
}
function closeLoading(){
	let node = document.getElementById('loading_div')
	if(node!=null){
		node.parentNode.removeChild(node)
	}
}
export default {
	loading:loading,
	closeLoading:closeLoading
}